import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import CheckEligibility from '../../services/check-eligibility.service';
import { AnalyticsService } from '../../services/analytics.service';
import axios from 'axios';
import './comparison-exchange.component.scss';
import * as $ from 'jquery';
import * as _ from 'lodash';
var ComparisonExchange = /** @class */ (function (_super) {
    tslib_1.__extends(ComparisonExchange, _super);
    function ComparisonExchange(element, analyticsService) {
        return _super.call(this, element) || this;
    }
    ComparisonExchange.prototype.init = function () {
        this.checkEligibility = new CheckEligibility();
        this.productKey = this.element.getAttribute('data-productkey');
        this.variableName = this.element.getAttribute('data-variablename');
        this.pricingAccordions = [];
        this.threeSelected = false;
        this.threeSelectedMessage = false;
        var tempStorageComparison = localStorage.getItem('comparison');
        var tempStorageCurrency = localStorage.getItem('currency');
        var tempStorageEligibility = localStorage.getItem('eligibility');
        this.containerCurrency = this.element.querySelector('.comparison-exchange__currencies');
        this.containerCurrencyButtons = this.element.querySelector('.comparison-exchange__currencies--items');
        this.containerComparisonCheckboxes = this.element.querySelector('.comparison-exchange__compare-chip-wrapper');
        this.containerSlots = Array.from(this.element.querySelectorAll('.comparison-exchange__slot'));
        this.containerAccordions = this.element.querySelector('.comparison-exchange__mobile__wrapper');
        if (!tempStorageComparison) {
            tempStorageComparison = {};
            tempStorageComparison[this.productKey] = [];
            localStorage.setItem('comparison', JSON.stringify(tempStorageComparison));
        }
        else {
            tempStorageComparison = JSON.parse(tempStorageComparison);
            if (!tempStorageComparison[this.productKey]) {
                tempStorageComparison[this.productKey] = [];
                localStorage.setItem('comparison', JSON.stringify(tempStorageComparison));
            }
        }
        if (!tempStorageCurrency) {
            tempStorageCurrency = {};
            tempStorageCurrency = "";
            localStorage.setItem('currency', JSON.stringify(tempStorageCurrency));
        }
        else {
            tempStorageCurrency = JSON.parse(tempStorageCurrency);
            if (!tempStorageCurrency) {
                tempStorageCurrency = "";
                localStorage.setItem('currency', JSON.stringify(tempStorageCurrency));
            }
        }
        if (!tempStorageEligibility) {
            tempStorageEligibility = {};
            localStorage.setItem('eligibility', JSON.stringify(tempStorageEligibility));
        }
        else {
            tempStorageEligibility = JSON.parse(tempStorageEligibility);
        }
        this.storageComparison = tempStorageComparison;
        this.storageCurrency = tempStorageCurrency;
        this.storageEligibility = tempStorageEligibility;
        this.storageJson = window[this.variableName];
        // init functions
        this.createProductCheckboxes();
        this.createCurrencyButtons();
        this.generateProducts();
        this.checkCheckBoxes();
    };
    ComparisonExchange.prototype.bindEvents = function () {
        var _this = this;
        this.clickProductCheckboxes.map(function (item) { return item.addEventListener('click', function (event) {
            if (_this.storageComparison) {
                if (_this.storageComparison[_this.productKey]) {
                    var element = event.target;
                    var id = element.getAttribute('data-id');
                    _this.actionProductClick(id);
                }
            }
        }); });
        this.clickProductLabel.map(function (item) { return item.addEventListener('click', function (event) {
            if (_this.threeSelected) {
                if (!_this.threeSelectedMessage) {
                    _this.threeSelectedMessage = true;
                    var maximumString = '<div class="comparison-exchange__compare-maximum-allowed">';
                    maximumString += '<div class="comparison-exchange__compare-maximum-allowed--close"><img src="/file_source/assets/icons/icon-close-white.svg" width=""40 /></div>';
                    maximumString += '<div class="comparison-exchange__compare-maximum-allowed--title">You can only compare 3 items</div>';
                    maximumString += '<div class="comparison-exchange__compare-maximum-allowed--description">Please deselect one item to select a new one</div>';
                    maximumString += '</div>';
                    var parentContainer = $('.comparison-exchange__compare-wrapper').closest('.col-12');
                    parentContainer.prepend(maximumString);
                }
            }
            else {
                $('div.comparison-exchange__compare-maximum-allowed').remove();
            }
        }); });
        if (this.clickCurrency) {
            this.clickCurrency.map(function (item) { return item.addEventListener('click', function (event) {
                var element = event.target;
                var currency = element.getAttribute('data-currency');
                _this.actionCurrencyClick(currency);
            }); });
        }
        $('.js-remove-all').click(function () {
            $('.comparison__slot').css('order', 99);
            _this.emptySlots();
            _this.emptySlotsMobile();
            $('.comparison-exchange').removeClass('comparison-exchange--comparing');
            $(".comparison-exchange__compare-checkbox input").removeAttr('disabled');
            $(".comparison-exchange__compare-checkbox input").prop('checked', false);
            _this.storageComparison[_this.productKey] = [];
            localStorage.setItem('comparison', JSON.stringify(_this.storageComparison));
            $('div.comparison-exchange__compare-maximum-allowed').remove();
        });
        $(document).on('click', 'a.js-recheck-eligibility', function (e) {
            var element = e.currentTarget;
            _this.recheckButton(element);
        });
        $(document).on('click', '.comparison-exchange__mobile__accordion__heading--container', function (e) {
            var closest = e.currentTarget.closest('.comparison-exchange__mobile__accordion');
            if ($(closest).hasClass('comparison-exchange__mobile__accordion--open')) {
                $(closest).toggleClass('comparison-exchange__mobile__accordion--open');
            }
            else {
                $('.comparison-exchange__mobile__accordion').removeClass('comparison-exchange__mobile__accordion--open');
                setTimeout(function () {
                    $(closest)
                        .toggleClass('comparison-exchange__mobile__accordion--open')
                        .queue(function (next) {
                        $('html,body').animate({
                            scrollTop: $(closest).offset().top - 70
                        }, 'slow');
                        next();
                    });
                }, 700);
            }
        });
        $(document).on('click', '.comparison-exchange__mobile__accordion__content', function (e) {
            // e.stopImmediatePropagation();
            // e.preventDefault();
        });
        $(document).on('click', '.comparison-exchange__compare-maximum-allowed--close', function (e) {
            $('div.comparison-exchange__compare-maximum-allowed').remove();
            _this.threeSelectedMessage = false;
        });
        // $(document).on('click', 'div.comparison-exchange__product__button[data-buttonclass=Apply]', (e) => {
        // 	let element: any;
        // 	if(e.currentTarget){
        // 		element = e.currentTarget;
        // 	}else{
        // 		element = e.target;
        // 	}
        // 	let getAnchor = element.querySelector('a');
        // 	let getLeadId = getAnchor.getAttribute('data-leadid');
        // 	let getProductName = getAnchor.getAttribute('data-productname');
        // 	let getClosestParent = element.closest('.comparison-exchange__product__section');
        // 	let getEligibilityMessage = getClosestParent.querySelector('.comparison-exchange__eligibility-message');
        // 	// APPLICATION ID
        // 	let valueProductID = $(element).closest('.js-product-id').attr('data-productid');
        // 	let valueEligibilityFormID = $(element).closest('.js-product-id').find('div[data-buttonclass=Eligibility]').find('.js-apply-now-modal-open').attr('data-modal');
        // 	console.log('Modal ID', valueEligibilityFormID);
        // 	console.log('Product ID', valueProductID);
        // 	this.checkEligibility.checkApplicationID(
        // 		valueEligibilityFormID, 
        // 		valueProductID
        // 	);
        // 	this.actionApplyNow(getLeadId, getProductName, getEligibilityMessage);
        // });
    };
    // generate products
    ComparisonExchange.prototype.generateProducts = function () {
        var _this = this;
        this.emptySlots();
        if (this.storageComparison) {
            if (this.storageComparison[this.productKey]) {
                var dataSlot_1 = 1;
                this.storageComparison[this.productKey].forEach(function (savedProduct) {
                    var renderSlot = $('.comparison-exchange__slot[data-slot=' + dataSlot_1 + ']');
                    _this.storageJson.products.forEach(function (product) {
                        if (product.id === savedProduct) {
                            var pricing = product.pricing;
                            pricing.forEach(function (price) {
                                var shortenedSubTitle = price.subTitle.trim().replace(/ /g, '').toLowerCase();
                                if (shortenedSubTitle === 'supportedcurrencies') {
                                    var getValue = price.title;
                                    if (getValue.indexOf(_this.storageCurrency) !== -1) {
                                        var renderProduct = _this.createDesktopProduct(product);
                                        $(renderSlot).html(renderProduct);
                                        dataSlot_1++;
                                    }
                                    else {
                                        if (_this.storageCurrency === 'OTHER') {
                                            var supportedCurrencies = getValue.split(',');
                                            if (supportedCurrencies.length > 5) {
                                                var renderProduct = _this.createDesktopProduct(product);
                                                $(renderSlot).html(renderProduct);
                                                dataSlot_1++;
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    });
                });
            }
        }
        this.createOriginalAccordions();
        this.normalizeHeight();
        this.recheckButtons = Array.from(this.element.querySelectorAll('.js-recheck-eligibility'));
        this.containerEligibilityMessage = Array.from(this.element.querySelectorAll('.comparison-exchange__product__section-eligibility--message'));
    };
    // DESKTOP | create product
    ComparisonExchange.prototype.createDesktopProduct = function (product) {
        var output = '';
        output += '<div class="comparison-exchange__product-wrapper js-product-id" data-productid="' + product.id + '" data-id="" data-trackingregion="compare bank accounts > ' + product.title + '">';
        output += '<div class="comparison-exchange__product__header">' + product.title + '</div>';
        output += '<div class="comparison-exchange__product__section" data-section="description">';
        output += '<span class="title title--notes">Description</span>';
        output += '<p>' + product.subTitle + '</p>';
        output += '</div>';
        output += this.createDesktopProductPricing(product.pricing);
        output += this.createDesktopButtons(product);
        output += this.createDesktopBenefitsAndFeatures(product.benefitsAndFeatures);
        output += '</div>';
        return output;
    };
    // DESKTOP | create product pricing
    ComparisonExchange.prototype.createDesktopProductPricing = function (pricing) {
        var _this = this;
        var output = '';
        var amountTerms = 0;
        if (pricing) {
            output += '<div class="comparison-exchange__product__section--prices">';
            pricing.forEach(function (price) {
                if (_this.storageCurrency) {
                    if (price.symbol === _this.storageCurrency) {
                        var object = _this.symbol(price.symbol);
                        var asterix = "";
                        if (price.terms) {
                            if (price.terms !== null) {
                                amountTerms++;
                                for (var index = 0; index < amountTerms; index++) {
                                    asterix += "*";
                                }
                            }
                        }
                        output += '<div class="comparison-exchange__product__section comparison-exchange__product__section--price">';
                        output += '<div class="title title--notes">' + price.subTitle + '</div>';
                        if (price.symbolHidden === 'false') {
                            output += '<span class="title title--initial title--currency-med">' + object.symbol + '</span>';
                        }
                        output += '<span class="' + _this.fontScale(price.title) + '">' + price.title + asterix + '</span>';
                        if (price.strike) {
                            output += '<div class="title title--number-strike">';
                            output += '<span class="title title--number-striker"></span>';
                            output += '<span class="title title--initial title--currency-sml">' + object.symbol + '</span>';
                            output += '<span class="title title--initial title--number-sml">' + price.strike + '</span>';
                            output += '</div>';
                        }
                        if (price.terms) {
                            if (price.terms !== null) {
                                output += '<p class="bodyText title title--initial title--currency-sml" style="width: 100% !important; text-align: center;">' + asterix + price.terms + '</p>';
                            }
                        }
                        output += '</div>';
                    }
                    else if (price.symbol === undefined) {
                        var asterix = "";
                        if (price.terms) {
                            if (price.terms !== null) {
                                amountTerms++;
                                for (var index = 0; index < amountTerms; index++) {
                                    asterix += "*";
                                }
                            }
                        }
                        output += '<div class="comparison-exchange__product__section comparison-exchange__product__section--price">';
                        output += '<div class="title title--notes">' + price.subTitle + '</div>';
                        output += '<span class="' + _this.fontScale(price.title) + '">' + price.title + asterix + '</span>';
                        if (price.terms) {
                            if (price.terms !== null) {
                                output += '<p class="bodyText title title--initial title--currency-sml" style="width: 100% !important; text-align: center;">' + asterix + price.terms + '</p>';
                            }
                        }
                        output += '</div>';
                    }
                }
                else {
                    if (price.symbol === "GBP") {
                        var object = _this.symbol(price.symbol);
                        var asterix = "";
                        if (price.terms) {
                            if (price.terms !== null) {
                                amountTerms++;
                                for (var index = 0; index < amountTerms; index++) {
                                    asterix += "*";
                                }
                            }
                        }
                        output += '<div class="comparison-exchange__product__section comparison-exchange__product__section--price">';
                        output += '<div class="title title--notes">' + price.subTitle + '</div>';
                        if (price.symbolHidden === 'false') {
                            output += '<span class="title title--initial title--currency-med">' + object.symbol + '</span>';
                        }
                        output += '<span class="' + _this.fontScale(price.title) + '">' + price.title + asterix + '</span>';
                        if (price.terms) {
                            if (price.terms !== null) {
                                output += '<p class="bodyText title title--initial title--currency-sml" style="width: 100% !important; text-align: center;">' + asterix + price.terms + '</p>';
                            }
                        }
                        output += '</div>';
                    }
                    else if (price.symbol === undefined) {
                        var asterix = "";
                        if (price.terms) {
                            if (price.terms !== null) {
                                amountTerms++;
                                for (var index = 0; index < amountTerms; index++) {
                                    asterix += "*";
                                }
                            }
                        }
                        output += '<div class="comparison-exchange__product__section comparison-exchange__product__section--price">';
                        output += '<div class="title title--notes">' + price.subTitle + '</div>';
                        output += '<span class="' + _this.fontScale(price.title) + '">' + price.title + asterix + '</span>';
                        if (price.terms) {
                            if (price.terms !== null) {
                                output += '<p class="bodyText title title--initial title--currency-sml" style="width: 100% !important; text-align: center;">' + asterix + price.terms + '</p>';
                            }
                        }
                        output += '</div>';
                    }
                }
            });
            output += '</div>';
        }
        return output;
    };
    // DESKTOP | create product eligibility message
    ComparisonExchange.prototype.createDesktopEligibilityMessage = function (result, modalId) {
        if (modalId === void 0) { modalId = ""; }
        var output = "";
        if (result) {
            if (result == "apply") {
                output += "<div class=\"comparison-exchange__eligibility-message comparison-exchange__eligibility-message--eligible\">";
                output += "You are eligible for this product.";
                output += "</div>";
            }
            else if (result == "apply_cmb") {
                output += "<div class=\"comparison-exchange__eligibility-message comparison-exchange__eligibility-message--eligible\">";
                output += "You are eligible for this product.";
                output += "</div>";
            }
            else if (result == "callmeback") {
                output += "<div class=\"comparison-exchange__eligibility-message comparison-exchange__eligibility-message--eligible\">";
                output += "You are eligible for this product.";
                output += "</div>";
            }
            else {
                output += "<div class=\"comparison-exchange__eligibility-message comparison-exchange__eligibility-message--invalid\">";
                output += "You are not eligible for this product. <a href=\"javascript:;\" class=\"js-apply-now-modal-open js-recheck-eligibility\" data-modal=\"" + modalId + "\">Recheck</a>";
                output += "</div>";
            }
        }
        return output;
    };
    // DESKTOP | create description block
    ComparisonExchange.prototype.createDesktopBenefitsAndFeatures = function (description) {
        var output = '';
        if (description) {
            if (description.length > 0) {
                output += '<div class="comparison-exchange__product__benefits">';
                output += '<span class="title title--notes">Benefits and Key Features</span>';
                output += '<ul>';
                description.forEach(function (desc) {
                    output += '<li>' + desc + '</li>';
                });
                output += '</ul>';
                output += '</div>';
            }
        }
        return output;
    };
    // DESKTOP | create buttons
    ComparisonExchange.prototype.createDesktopButtons = function (product, desktop) {
        var _this = this;
        if (desktop === void 0) { desktop = true; }
        var output = '';
        if (product.buttons) {
            if (product.buttons.length > 0) {
                if (desktop) {
                    output += '<div class="comparison-exchange__product__section comparison-exchange__product__section--wide">';
                    // check buttonClasses for 'Eligibility' and get modalId
                    var eligibility_1 = false;
                    var eligiblityModalId_1 = '';
                    product.buttons.forEach(function (button) {
                        if (button.buttonClass === 'Eligibility') {
                            eligibility_1 = true;
                            eligiblityModalId_1 = 'apply-now-modal-' + button.modalId;
                        }
                    });
                    // add eligibility message
                    output += '<div class="comparison-exchange__product__section-eligibility--message">';
                    if (this.storageEligibility[eligiblityModalId_1]) {
                        output += this.createDesktopEligibilityMessage(this.storageEligibility[eligiblityModalId_1].result, eligiblityModalId_1);
                    }
                    output += '</div>';
                    // print buttons
                    output += '<div class="comparison-exchange__product__section-buttons"	>';
                    var index_1 = 0;
                    product.buttons.forEach(function (button) {
                        output += '<div class="comparison-exchange__product__button" data-buttonclass="' + button.buttonClass + '">';
                        if (eligibility_1) {
                            if (_this.storageEligibility[eligiblityModalId_1]) {
                                if (_this.storageEligibility[eligiblityModalId_1].result == "apply") {
                                    if (button.buttonClass == 'Apply' || button.buttonClass == 'ProductDetails') {
                                        output += _this.buttonCreator(product, button, index_1, true, _this.storageEligibility[eligiblityModalId_1].leadID);
                                    }
                                    else {
                                        output += _this.buttonCreator(product, button, index_1, false, _this.storageEligibility[eligiblityModalId_1].leadID);
                                    }
                                }
                                else if (_this.storageEligibility[eligiblityModalId_1].result == "apply_cmb") {
                                    if (button.buttonClass == 'Apply' || button.buttonClass == 'ProductDetails') {
                                        output += _this.buttonCreator(product, button, index_1, true, _this.storageEligibility[eligiblityModalId_1].leadID);
                                    }
                                    else {
                                        output += _this.buttonCreator(product, button, index_1, false, _this.storageEligibility[eligiblityModalId_1].leadID);
                                    }
                                }
                                else if (_this.storageEligibility[eligiblityModalId_1].result == "callmeback") {
                                    if (button.buttonClass == 'CallMeBack' || button.buttonClass == 'ProductDetails') {
                                        output += _this.buttonCreator(product, button, index_1, true, _this.storageEligibility[eligiblityModalId_1].leadID);
                                    }
                                    else {
                                        output += _this.buttonCreator(product, button, index_1, false), _this.storageEligibility[eligiblityModalId_1].leadID;
                                    }
                                }
                                else if (_this.storageEligibility[eligiblityModalId_1].result == "contactus") {
                                    if (button.buttonClass == 'ContactUs' || button.buttonClass == 'ProductDetails') {
                                        output += _this.buttonCreator(product, button, index_1, true), _this.storageEligibility[eligiblityModalId_1].leadID;
                                    }
                                    else {
                                        output += _this.buttonCreator(product, button, index_1, false, _this.storageEligibility[eligiblityModalId_1].leadID);
                                    }
                                }
                                else {
                                    output += _this.buttonCreator(product, button, index_1, false, _this.storageEligibility[eligiblityModalId_1].leadID);
                                }
                            }
                            else {
                                if (button.buttonClass === 'Eligibility' || button.buttonClass === 'ProductDetails') {
                                    output += _this.buttonCreator(product, button, index_1, true);
                                }
                                else {
                                    output += _this.buttonCreator(product, button, index_1, false);
                                }
                            }
                        }
                        else {
                            output += _this.buttonCreator(product, button, index_1, true);
                        }
                        output += button.title;
                        output += '</a>';
                        output += '</div>';
                        index_1++;
                    });
                    output += '</div>';
                    output += '</div>';
                }
                else {
                    output += '<div class="comparison-exchange__product__eligiblity__mobile" style="width: 100%; display: inline-block; float: left;">';
                    // check buttonClasses for 'Eligibility' and get modalId
                    var eligibility_2 = false;
                    var eligiblityModalId_2 = '';
                    product.buttons.forEach(function (button) {
                        if (button.buttonClass === 'Eligibility') {
                            eligibility_2 = true;
                            eligiblityModalId_2 = button.modalId;
                        }
                    });
                    // add eligibility message
                    output += '<div class="comparison-exchange__product__section-eligibility--message--mobile">';
                    if (this.storageEligibility[eligiblityModalId_2]) {
                        output += this.createDesktopEligibilityMessage(this.storageEligibility[eligiblityModalId_2].result, eligiblityModalId_2);
                    }
                    output += '</div>';
                    // print buttons
                    output += '<div class="comparison-exchange__product__section-buttons--mobile"	>';
                    var index_2 = 0;
                    product.buttons.forEach(function (button) {
                        output += '<div class="comparison-exchange__product__button" data-buttonclass="' + button.buttonClass + '">';
                        if (eligibility_2) {
                            if (_this.storageEligibility[eligiblityModalId_2]) {
                                if (_this.storageEligibility[eligiblityModalId_2].result == "apply") {
                                    if (button.buttonClass == 'Apply' || button.buttonClass == 'ProductDetails') {
                                        output += _this.buttonCreator(product, button, index_2, true);
                                    }
                                    else {
                                        output += _this.buttonCreator(product, button, index_2, false);
                                    }
                                }
                                else if (_this.storageEligibility[eligiblityModalId_2].result == "callmeback") {
                                    if (button.buttonClass == 'CallMeBack' || button.buttonClass == 'ProductDetails') {
                                        output += _this.buttonCreator(product, button, index_2, true);
                                    }
                                    else {
                                        output += _this.buttonCreator(product, button, index_2, false);
                                    }
                                }
                                else if (_this.storageEligibility[eligiblityModalId_2].result == "contactus") {
                                    if (button.buttonClass == 'ContactUs' || button.buttonClass == 'ProductDetails') {
                                        output += _this.buttonCreator(product, button, index_2, true);
                                    }
                                    else {
                                        output += _this.buttonCreator(product, button, index_2, false);
                                    }
                                }
                                else {
                                    output += _this.buttonCreator(product, button, index_2, false);
                                }
                            }
                            else {
                                if (button.buttonClass === 'Eligibility' || button.buttonClass === 'ProductDetails') {
                                    output += _this.buttonCreator(product, button, index_2, true);
                                }
                                else {
                                    output += _this.buttonCreator(product, button, index_2, false);
                                }
                            }
                        }
                        else {
                            output += _this.buttonCreator(product, button, index_2, true);
                        }
                        output += button.title;
                        output += '</a>';
                        output += '</div>';
                        index_2++;
                    });
                    output += '</div>';
                    output += '</div>';
                }
            }
        }
        return output;
    };
    // empty all slots
    ComparisonExchange.prototype.emptySlots = function () {
        var output = "";
        output = '<div class="comparison-exchange__placeholder comparison-exchange__placeholder--col">';
        output += '<svg viewBox="0 0 300 100" preserveAspectRatio="none">';
        output += '<path d="M0,0 300,0 300,100 0,100z" vector-effect="non-scaling-stroke"></path>';
        output += '</svg>';
        output += '<span class="comparison-exchange__placeholder__icon">';
        output += '<i data-component="icon" data-icon="icon-hand" data-gradient="" data-path="/file_source/assets/icons/" class="icon "><!--?xml version="1.0" encoding="UTF-8"?--><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="32px" height="34px" viewBox="0 0 32 34" version="1.1">';
        output += '<!-- Generator: Sketch 48.1 (47250) - http://www.bohemiancoding.com/sketch -->';
        output += '<title>icon-hand</title>';
        output += '<desc>Created with Sketch.</desc>';
        output += '<defs><linearGradient xy="100%" id="gradient"><stop stop-color="#fff" offset="0%"></stop><stop stop-color="#fff" offset="100%"></stop></linearGradient></defs>';
        output += '<g id="Standard-Bank---Icon-Setup" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-101.000000, -937.000000)">';
        output += '<g id="icon-hand" transform="translate(101.000000, 937.000000)" fill="#858D9D">';
        output += '<path d="M28.928,20.563 L28.928,22.638 C28.9318225,25.7700626 27.2178643,28.6520005 24.464,30.144 C21.284,31.85 17.274,31.3 14.709,28.984 L4.161,18.548 C6.311,17.326 9.452,17.717 11.246,19.508 L12.788,21.053 C13.165,21.428 13.662,21.635 14.189,21.635 C15.2864864,21.6350022 16.176794,20.7464842 16.179,19.649 L16.179,4.25 C16.179,3.47 16.813,2.833 17.595,2.833 C18.377,2.833 19.012,3.469 19.012,4.25 L19.012,13.48 L28.928,20.563 Z M21.845,4.25 C21.8422448,1.90393201 19.941068,0.00275522069 17.595,-4.72399897e-16 C15.248932,0.00275522069 13.3477552,1.90393201 13.345,4.25 L13.345,17.604 L13.249,17.506 C11.638,15.896 9.376,14.973 7.042,14.973 C4.734,14.973 2.592,15.84 1.012,17.413 L0,18.418 L12.763,31.041 C14.8624617,32.9440426 17.5943965,33.9986799 20.428,34 C22.31,34 24.116,33.544 25.806,32.64 C29.4793082,30.654667 31.7666556,26.8134902 31.762,22.638 L31.762,19.104 L21.845,12.02 L21.845,4.25 Z" id="Shape"></path>';
        output += '</g>';
        output += '</g>';
        output += '</svg></i>';
        output += '</span>';
        output += '<span class="comparison-exchange__placeholder__text">';
        output += 'Use the tags to select a product to compare';
        output += '</span>';
        output += '</div>';
        this.containerSlots.map(function (element) {
            element.innerHTML = output;
        });
    };
    // empty all slots - mobile
    ComparisonExchange.prototype.emptySlotsMobile = function () {
        var output = "";
        output = '<div class="comparison-exchange__placeholder comparison-exchange__placeholder--col">';
        output += '<svg viewBox="0 0 300 100" preserveAspectRatio="none">';
        output += '<path d="M0,0 300,0 300,100 0,100z" vector-effect="non-scaling-stroke"></path>';
        output += '</svg>';
        output += '<span class="comparison-exchange__placeholder__icon">';
        output += '<i data-component="icon" data-icon="icon-hand" data-gradient="" data-path="/file_source/assets/icons/" class="icon "><!--?xml version="1.0" encoding="UTF-8"?--><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="32px" height="34px" viewBox="0 0 32 34" version="1.1">';
        output += '<!-- Generator: Sketch 48.1 (47250) - http://www.bohemiancoding.com/sketch -->';
        output += '<title>icon-hand</title>';
        output += '<desc>Created with Sketch.</desc>';
        output += '<defs><linearGradient xy="100%" id="gradient"><stop stop-color="#fff" offset="0%"></stop><stop stop-color="#fff" offset="100%"></stop></linearGradient></defs>';
        output += '<g id="Standard-Bank---Icon-Setup" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-101.000000, -937.000000)">';
        output += '<g id="icon-hand" transform="translate(101.000000, 937.000000)" fill="#858D9D">';
        output += '<path d="M28.928,20.563 L28.928,22.638 C28.9318225,25.7700626 27.2178643,28.6520005 24.464,30.144 C21.284,31.85 17.274,31.3 14.709,28.984 L4.161,18.548 C6.311,17.326 9.452,17.717 11.246,19.508 L12.788,21.053 C13.165,21.428 13.662,21.635 14.189,21.635 C15.2864864,21.6350022 16.176794,20.7464842 16.179,19.649 L16.179,4.25 C16.179,3.47 16.813,2.833 17.595,2.833 C18.377,2.833 19.012,3.469 19.012,4.25 L19.012,13.48 L28.928,20.563 Z M21.845,4.25 C21.8422448,1.90393201 19.941068,0.00275522069 17.595,-4.72399897e-16 C15.248932,0.00275522069 13.3477552,1.90393201 13.345,4.25 L13.345,17.604 L13.249,17.506 C11.638,15.896 9.376,14.973 7.042,14.973 C4.734,14.973 2.592,15.84 1.012,17.413 L0,18.418 L12.763,31.041 C14.8624617,32.9440426 17.5943965,33.9986799 20.428,34 C22.31,34 24.116,33.544 25.806,32.64 C29.4793082,30.654667 31.7666556,26.8134902 31.762,22.638 L31.762,19.104 L21.845,12.02 L21.845,4.25 Z" id="Shape"></path>';
        output += '</g>';
        output += '</g>';
        output += '</svg></i>';
        output += '</span>';
        output += '<span class="comparison-exchange__placeholder__text">';
        output += 'Use the tags to select a product to compare';
        output += '</span>';
        output += '</div>';
        this.containerAccordions.innerHTML = output;
    };
    // create product checkboxes
    ComparisonExchange.prototype.createProductCheckboxes = function () {
        var _this = this;
        if (this.storageJson) {
            var output_1 = '';
            this.storageJson.products.forEach(function (product) {
                output_1 += '<label class="comparison-exchange__compare-checkbox form__control form__control--checkbox">';
                output_1 += product.shortTitle;
                if (_this.storageComparison) {
                    if (_this.storageComparison[_this.productKey]) {
                        if (_this.storageComparison[_this.productKey].indexOf(product.id) > -1) {
                            output_1 += '<input type="checkbox" data-id="' + product.id + '" class="js-compare" checked>';
                        }
                        else {
                            output_1 += '<input type="checkbox" data-id="' + product.id + '" class="js-compare">';
                        }
                    }
                    else {
                        output_1 += '<input type="checkbox" data-id="' + product.id + '" class="js-compare">';
                    }
                }
                else {
                    output_1 += '<input type="checkbox" data-id="' + product.id + '" class="js-compare">';
                }
                output_1 += '<div class="form__control-indicator"></div>';
                output_1 += '</label>';
            });
            this.containerComparisonCheckboxes.innerHTML = output_1;
            this.clickProductCheckboxes = Array.from(this.element.querySelectorAll('.js-compare'));
            this.clickProductLabel = Array.from(this.element.querySelectorAll('.comparison-exchange__compare-checkbox'));
        }
    };
    // create currency buttons
    ComparisonExchange.prototype.createCurrencyButtons = function () {
        var _this = this;
        if (this.storageCurrency) {
            var output_2 = '';
            this.storageJson.currencies.forEach(function (currency) {
                if (_this.symbol(currency)) {
                    var object = _this.symbol(currency);
                    if (_this.storageCurrency) {
                        if (_this.storageCurrency === object.symbolName) {
                            output_2 += "<a javascript:void(0) data-currency=\"" + object.symbolName + "\" class=\"comparison-exchange__currencies--item comparison-exchange__currencies--item__active\" style=\"background-image: url('" + object.image + "');\">";
                        }
                        else {
                            output_2 += "<a javascript:void(0) data-currency=\"" + object.symbolName + "\" class=\"comparison-exchange__currencies--item\" style=\"background-image: url('" + object.image + "');\">";
                        }
                    }
                    else {
                        output_2 += "<a javascript:void(0) data-currency=\"" + object.symbolName + "\" class=\"comparison-exchange__currencies--item\" style=\"background-image: url('" + object.image + "');\">";
                    }
                    output_2 += object.title;
                    output_2 += "</a>";
                }
            });
            this.containerCurrencyButtons.innerHTML = output_2;
            this.clickCurrency = Array.from(this.element.querySelectorAll('.comparison-exchange__currencies--item'));
        }
        else {
            var output_3 = '';
            this.storageJson.currencies.forEach(function (currency) {
                if (_this.symbol(currency)) {
                    var object = _this.symbol(currency);
                    output_3 += "<a javascript:void(0) data-currency=\"" + object.symbolName + "\" class=\"comparison-exchange__currencies--item\" style=\"background-image: url('" + object.image + "');\">";
                    output_3 += object.title;
                    output_3 += "</a>";
                }
            });
            this.containerCurrencyButtons.innerHTML = output_3;
            this.clickCurrency = Array.from(this.element.querySelectorAll('.comparison-exchange__currencies--item'));
        }
    };
    // click product checkbox
    ComparisonExchange.prototype.actionProductClick = function (id) {
        var _this = this;
        if (id) {
            if (this.storageComparison[this.productKey].indexOf(id) > -1) {
                var index = this.storageComparison[this.productKey].indexOf(id);
                this.storageComparison[this.productKey].splice(index, 1);
                localStorage.setItem('comparison', JSON.stringify(this.storageComparison));
            }
            else {
                this.storageComparison[this.productKey].push(id);
                localStorage.setItem('comparison', JSON.stringify(this.storageComparison));
            }
            if (this.storageComparison[this.productKey].length === 0) {
                this.element.classList.remove('comparison-exchange--comparing');
                $('.comparison-exchange__compare-checkbox input').removeAttr('disabled');
                this.emptySlots();
                this.emptySlotsMobile();
                this.threeSelected = false;
                this.threeSelectedMessage = false;
            }
            else {
                if (this.storageComparison[this.productKey].length > 0) {
                    this.element.classList.add('comparison-exchange--comparing');
                    if (this.storageComparison[this.productKey].length === 3) {
                        $('.comparison-exchange__compare-checkbox input').prop('disabled', 'disabled');
                        this.storageComparison[this.productKey].forEach(function (id) {
                            $('.comparison-exchange__compare-checkbox input[data-id=' + id + ']').removeAttr('disabled');
                        });
                        setTimeout(function () {
                            _this.threeSelected = true;
                        }, 200);
                    }
                    else {
                        $('.comparison-exchange__compare-checkbox input').removeAttr('disabled');
                        this.threeSelected = false;
                        this.threeSelectedMessage = false;
                    }
                }
                this.generateProducts();
            }
        }
    };
    // click currency button
    ComparisonExchange.prototype.actionCurrencyClick = function (currency) {
        var _this = this;
        if (currency) {
            this.storageCurrency = currency;
            this.clickCurrency.map(function (button) {
                button.classList.remove('comparison-exchange__currencies--item__active');
                if (button.getAttribute('data-currency') === _this.storageCurrency) {
                    button.classList.add('comparison-exchange__currencies--item__active');
                }
            });
            localStorage.setItem('currency', JSON.stringify(this.storageCurrency));
            this.generateProducts();
        }
    };
    // create mobile original accordions
    ComparisonExchange.prototype.createOriginalAccordions = function () {
        var output = '';
        if (this.storageComparison) {
            if (this.storageComparison[this.productKey]) {
                output += this.createMobileDescription();
                output += this.createMobilePricingAccordions();
                output += this.createMobileBenefitsAndFeatures();
            }
        }
        this.containerAccordions.innerHTML = output;
        return output;
    };
    // create description accordion
    ComparisonExchange.prototype.createMobileDescription = function () {
        var _this = this;
        var output = '<div class="comparison-exchange__mobile__accordion" data-section="description" data-id="link_accordion_accordion" data-text="compare bank accounts | description">';
        output += '<span class="comparison-exchange__mobile__accordion__heading--container">';
        output += '<span class="comparison-exchange__mobile__accordion__heading">Description</span>';
        output += '<span class="comparison-exchange__mobile__chevron"><i data-component="icon" data-icon="link-chevron" class="icon "><!--?xml version="1.0" encoding="UTF-8"?--><svg width="6px" height="9px" viewBox="0 0 6 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Dsk-/-arrow-/-blue" fill-rule="nonzero" fill="#0089FF"><polygon id="flechita" points="1.22288019 9 5.72288019 4.5 1.22288019 0 0 0.322880195 4.17711981 4.5 0 8.67711981"></polygon></g></g></svg></i></span>';
        output += '</span>';
        output += '<div class="comparison-exchange__mobile__accordion__content">';
        if (this.storageComparison[this.productKey]) {
            this.storageComparison[this.productKey].forEach(function (savedProduct) {
                if (_this.storageJson) {
                    _this.storageJson.products.forEach(function (product) {
                        if (product.id === savedProduct) {
                            var pricing = product.pricing;
                            pricing.forEach(function (price) {
                                var shortenedSubTitle = price.subTitle.trim().replace(/ /g, '').toLowerCase();
                                if (shortenedSubTitle === 'supportedcurrencies') {
                                    var getValue = price.title;
                                    if (getValue.indexOf(_this.storageCurrency) !== -1) {
                                        output += '<div class="comparison-exchange__mobile__accordion__content__wrapper" data-id="' + product.id + '" data-trackingregion="compare bank accounts > ' + product.title + '">';
                                        output += '<div class="comparison-exchange__mobile__title">';
                                        output += product.title;
                                        output += '</div>';
                                        output += '<p>';
                                        output += product.subTitle;
                                        output += '</p>';
                                        output += _this.createDesktopButtons(product, false);
                                        output += '</div>';
                                    }
                                    else {
                                        if (_this.storageCurrency === 'OTHER') {
                                            var supportedCurrencies = getValue.split(',');
                                            if (supportedCurrencies.length > 5) {
                                                output += '<div class="comparison-exchange__mobile__accordion__content__wrapper" data-id="' + product.id + '" data-trackingregion="compare bank accounts > ' + product.title + '">';
                                                output += '<div class="comparison-exchange__mobile__title">';
                                                output += product.title;
                                                output += '</div>';
                                                output += '<p>';
                                                output += product.subTitle;
                                                output += '</p>';
                                                output += _this.createDesktopButtons(product, false);
                                                output += '</div>';
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    });
                }
            });
        }
        output += '</div>';
        output += '</div>';
        return output;
    };
    // create pricing accordions
    ComparisonExchange.prototype.createMobilePricingAccordions = function () {
        var _this = this;
        var output = '';
        if (this.storageComparison[this.productKey]) {
            var getStoredProducts_1 = [];
            var getUniquesSubTitles_1 = [];
            this.storageComparison[this.productKey].forEach(function (element) {
                _.find(_this.storageJson.products, function (o) {
                    if (o.id === element) {
                        var pricing = o.pricing;
                        pricing.forEach(function (price) {
                            var shortenedSubTitle = price.subTitle.trim().replace(/ /g, '').toLowerCase();
                            if (shortenedSubTitle === 'supportedcurrencies') {
                                var getValue = price.title;
                                if (getValue.indexOf(_this.storageCurrency) !== -1) {
                                    getStoredProducts_1.push(o);
                                }
                                else {
                                    if (_this.storageCurrency === 'OTHER') {
                                        var supportedCurrencies = getValue.split(',');
                                        if (supportedCurrencies.length > 5) {
                                            getStoredProducts_1.push(o);
                                        }
                                    }
                                }
                            }
                        });
                    }
                    ;
                });
            });
            getStoredProducts_1.forEach(function (product) {
                product.pricing.forEach(function (pricing) {
                    var price = pricing.subTitle.trim();
                    if (getUniquesSubTitles_1.indexOf(price) === -1) {
                        getUniquesSubTitles_1.push(price);
                    }
                });
            });
            var pricingJson_1 = (_.groupBy(_.flatMap(getStoredProducts_1.map(function (product) {
                return product.pricing.map(function (price) {
                    price.id = product.id;
                    price.productTitle = product.title;
                    price.productShortTitle = product.shortTitle;
                    price.productLink = product.productLink;
                    price.buttons = product.buttons;
                    return price;
                });
            })), 'subTitle'));
            _.mapKeys(pricingJson_1, function (value, key) {
                var maxValue = _.max(_.map(pricingJson_1[key], function (price) {
                    var priceMax = price.title.trim().replace(/ /g, '');
                    return parseInt(priceMax);
                }));
                pricingJson_1[key].forEach(function (price) {
                    var pricePercentage = price.title.trim().replace(/ /g, '');
                    price.percent = _.round(parseInt(pricePercentage) / maxValue * 100, 0);
                });
            });
            for (var accordion in pricingJson_1) {
                output += '<div class="comparison-exchange__mobile__accordion" data-section="' + accordion + '" data-id="link_accordion_accordion" data-text="compare bank accounts | ' + accordion + '">';
                output += '<span class="comparison-exchange__mobile__accordion__heading--container">';
                output += '<span class="comparison-exchange__mobile__accordion__heading">' + accordion + '</span>';
                output += '<span class="comparison-exchange__mobile__chevron"><i data-component="icon" data-icon="link-chevron" class="icon "><!--?xml version="1.0" encoding="UTF-8"?--><svg width="6px" height="9px" viewBox="0 0 6 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Dsk-/-arrow-/-blue" fill-rule="nonzero" fill="#0089FF"><polygon id="flechita" points="1.22288019 9 5.72288019 4.5 1.22288019 0 0 0.322880195 4.17711981 4.5 0 8.67711981"></polygon></g></g></svg></i></span>';
                output += '</span>';
                output += '<div class="comparison-exchange__mobile__accordion__content">';
                output += '<div class="comparison-exchange__mobile__graph-wrapper">';
                output += '<div class="comparison-exchange__mobile__graph-wrapper__inner">';
                output += this.createMobileAccordionContent(pricingJson_1[accordion], accordion);
                output += '</div>';
                output += '</div>';
                output += '</div>';
                output += '</div>';
            }
        }
        return output;
    };
    // create specific content for pricing
    ComparisonExchange.prototype.createMobileAccordionContent = function (pricingJson, subTitle) {
        var _this = this;
        var output = '';
        var shortenedSubTitle = subTitle.trim().replace(/ /g, '');
        if (pricingJson) {
            pricingJson.forEach(function (price) {
                if (price.symbol === _this.storageCurrency) {
                    var object = _this.symbol(price.symbol);
                    if (price.symbolHidden === "true") {
                        output += '<div class="comparison-exchange__mobile__graph-item" data-id="' + price.id + '">';
                        output += '<div class="comparison-exchange__mobile__graph__title">';
                        output += price.productTitle;
                        output += '</div>';
                        output += '<span class="title title--initial title--number-sml">' + price.title + '</span>';
                        output += '</div>';
                    }
                    else {
                        output += '<div class="comparison-exchange__mobile__graph-item" data-id="' + price.id + '">';
                        output += '<div class="comparison-exchange__mobile__graph__title">';
                        output += price.productTitle;
                        output += '</div>';
                        output += '<span class="title title--initial title--currency-sml">' + object.symbol + '</span>';
                        output += '<span class="title title--initial title--number-sml">' + price.title + '</span>';
                        output += '<div class="comparison-exchange__mobile__graph__bar">';
                        output += '<div class="comparison-exchange__mobile__graph__bar__fill" style="width: ' + price.percent + '%">';
                        output += '</div>';
                        output += '</div>';
                        output += '</div>';
                    }
                }
                else if (price.symbol === undefined) {
                    output += '<div class="comparison-exchange__mobile__graph-item" data-id="' + price.id + '" style="margin-bottom: 5px">';
                    output += '<div class="comparison-exchange__mobile__graph__title">';
                    output += price.productTitle;
                    output += '</div>';
                    output += '<span class="title title--initial title--number-sml">' + price.title + '</span>';
                    output += '</div>';
                }
            });
        }
        return output;
    };
    // create benefits and features accordion
    ComparisonExchange.prototype.createMobileBenefitsAndFeatures = function () {
        var _this = this;
        var output = '<div class="comparison-exchange__mobile__accordion" data-section="benefits" data-id="link_accordion_accordion" data-text="compare bank accounts | benefits">';
        output += '<span class="comparison-exchange__mobile__accordion__heading--container">';
        output += '<span class="comparison-exchange__mobile__accordion__heading">Benefits & Key Features</span>';
        output += '<span class="comparison-exchange__mobile__chevron"><i data-component="icon" data-icon="link-chevron" class="icon "><!--?xml version="1.0" encoding="UTF-8"?--><svg width="6px" height="9px" viewBox="0 0 6 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Dsk-/-arrow-/-blue" fill-rule="nonzero" fill="#0089FF"><polygon id="flechita" points="1.22288019 9 5.72288019 4.5 1.22288019 0 0 0.322880195 4.17711981 4.5 0 8.67711981"></polygon></g></g></svg></i></span>';
        output += '</span>';
        output += '<div class="comparison-exchange__mobile__accordion__content">';
        if (this.storageComparison[this.productKey]) {
            this.storageComparison[this.productKey].forEach(function (savedProduct) {
                if (_this.storageJson) {
                    _this.storageJson.products.forEach(function (product) {
                        if (product.id === savedProduct) {
                            var pricing = product.pricing;
                            pricing.forEach(function (price) {
                                var shortenedSubTitle = price.subTitle.trim().replace(/ /g, '').toLowerCase();
                                if (shortenedSubTitle === 'supportedcurrencies') {
                                    var getValue = price.title;
                                    if (getValue.indexOf(_this.storageCurrency) !== -1) {
                                        output += '<div class="comparison-exchange__mobile__accordion__content__wrapper" data-id="' + product.id + '" data-trackingregion="compare bank accounts > ' + product.title + '">';
                                        output += '<div class="comparison-exchange__mobile__title">';
                                        output += product.title;
                                        output += '</div>';
                                        output += '<span class="title title--notes">BENEFITS AND KEY FEATURES</span>';
                                        output += '<ul>';
                                        product.benefitsAndFeatures.forEach(function (benefit) {
                                            output += '<li>' + benefit + '</li>';
                                        });
                                        output += '<ul>';
                                        output += '</div>';
                                    }
                                    else {
                                        if (_this.storageCurrency === 'OTHER') {
                                            var supportedCurrencies = getValue.split(',');
                                            if (supportedCurrencies.length > 5) {
                                                output += '<div class="comparison-exchange__mobile__accordion__content__wrapper" data-id="' + product.id + '" data-trackingregion="compare bank accounts > ' + product.title + '">';
                                                output += '<div class="comparison-exchange__mobile__title">';
                                                output += product.title;
                                                output += '</div>';
                                                output += '<span class="title title--notes">BENEFITS AND KEY FEATURES</span>';
                                                output += '<ul>';
                                                product.benefitsAndFeatures.forEach(function (benefit) {
                                                    output += '<li>' + benefit + '</li>';
                                                });
                                                output += '<ul>';
                                                output += '</div>';
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    });
                }
            });
        }
        output += '</div>';
        output += '</div>';
        return output;
    };
    // functions
    ComparisonExchange.prototype.debounce = function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate)
                    func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow)
                func.apply(context, args);
        };
    };
    ;
    ComparisonExchange.prototype.fontScale = function (text) {
        var fontClasses = "title title--initial title--number-med";
        if (text) {
            if (text.length > 20) {
                fontClasses = "title";
            }
        }
        return fontClasses;
    };
    // normalize layout
    ComparisonExchange.prototype.normalizeHeight = function () {
        var products = $('.comparison-exchange__product-wrapper');
        var minHeight = 0;
        if (products.length > 0) {
            products.each(function (idx, el) {
                if ($(el).outerHeight() > minHeight) {
                    minHeight = $(el).outerHeight();
                }
            });
            $('.comparison-exchange__placeholder--col').css('min-height', minHeight + "px");
        }
        var descriptions = $('.comparison-exchange__product__section[data-section="description"]');
        minHeight = 0; //reset
        if (descriptions.length > 0) {
            descriptions.each(function (idx, el) {
                if ($(el).outerHeight() > minHeight) {
                    minHeight = $(el).outerHeight();
                }
            });
            $('.comparison-exchange__product__section[data-section="description"]').css('min-height', minHeight + "px");
        }
        var applications = $('.comparison-exchange__product__section[data-section="apply"]');
        minHeight = 0; //reset
        if (applications.length > 0) {
            applications.each(function (idx, el) {
                if ($(el).height() > minHeight) {
                    minHeight = $(el).height();
                }
            });
            $('.comparison-exchange__product__section[data-section="apply"]').css('min-height', minHeight + "px");
        }
        // prices container min-height
        var prices = $('.comparison-exchange__product__section--prices');
        minHeight = 0; //reset
        if (prices.length > 0) {
            prices.each(function (idx, el) {
                if ($(el).height() > minHeight) {
                    minHeight = $(el).height();
                }
            });
            $('.comparison-exchange__product__section--prices').css('min-height', minHeight + "px");
        }
        // prices container per item min-height
        var pricesContainer = $('.comparison-exchange__product__section--prices');
        var arrayHeight = [];
        minHeight = 0; //reset
        if (pricesContainer.length > 0) {
            pricesContainer.each(function (indexParent, elParent) {
                var priceItem = $(elParent).find('div.comparison-exchange__product__section--price');
                var indexChild = 0;
                priceItem.each(function (index, value) {
                    if (arrayHeight[indexChild]) {
                        if (arrayHeight[indexChild] < $(value).outerHeight()) {
                            arrayHeight[indexChild] = $(value).outerHeight();
                        }
                    }
                    else {
                        arrayHeight[indexChild] = $(value).outerHeight();
                    }
                    indexChild++;
                });
            });
        }
        if (pricesContainer.length > 0) {
            pricesContainer.each(function (indexParent, elParent) {
                var priceItem = $(elParent).find('div.comparison-exchange__product__section--price');
                var indexChild = 0;
                priceItem.each(function (index, value) {
                    $(value).css('min-height', arrayHeight[indexChild] + "px");
                    indexChild++;
                });
            });
        }
        // benefits container min-height
        var benefits = $('.comparison-exchange__product__benefits');
        minHeight = 0; //reset
        if (benefits.length > 0) {
            benefits.each(function (idx, el) {
                if ($(el).outerHeight() > minHeight) {
                    minHeight = $(el).outerHeight();
                }
            });
            $('.comparison-exchange__product__benefits').css('min-height', minHeight + "px");
        }
        var buttons = $('.comparison-exchange__product__section-buttons');
        minHeight = 0; //reset
        if (buttons.length > 0) {
            buttons.each(function (idx, el) {
                if ($(el).height() > minHeight) {
                    minHeight = $(el).height();
                }
            });
            $('.comparison-exchange__product__section-buttons').css('min-height', minHeight + "px");
        }
        var message = $('.comparison-exchange__product__section-eligibility--message');
        minHeight = 0; //reset
        if (message.length > 0) {
            message.each(function (idx, el) {
                if ($(el).height() > minHeight) {
                    minHeight = $(el).height();
                }
            });
            $('.comparison-exchange__product__section-eligibility--message').css('min-height', minHeight + "px");
        }
    };
    ComparisonExchange.prototype.buttonCreator = function (product, button, index, show, leadid) {
        if (index === void 0) { index = 0; }
        if (show === void 0) { show = false; }
        if (leadid === void 0) { leadid = ''; }
        var output = '';
        var dataIntent = 'Informational';
        var dataClass = 'button--main';
        if (button.buttonClass) {
            var dataButtonClass = button.buttonClass.toLowerCase();
            if (dataButtonClass === 'eligibility') {
                dataIntent = 'Transactional';
                dataClass = 'button--main';
            }
            else if (dataButtonClass === 'callmeback') {
                dataIntent = 'Query';
                dataClass = 'button--main';
            }
            else if (dataButtonClass === 'apply') {
                dataIntent = 'Transactional';
                dataClass = 'button--main';
            }
            else if (dataButtonClass === 'applywhitebutton') {
                dataIntent = 'Transactional';
                dataClass = 'button--white button--border-blue';
            }
            else if (dataButtonClass === 'contactus') {
                dataIntent = 'Query';
                dataClass = 'button--white button--border-blue';
            }
            else if (dataButtonClass === 'contact us') {
                dataIntent = 'Query';
                dataClass = 'button--white button--border-blue';
            }
            else if (dataButtonClass === 'contact') {
                dataIntent = 'Query';
                dataClass = 'button--white button--border-blue';
            }
            else if (dataButtonClass === 'productdetails') {
                dataIntent = 'Informational';
                dataClass = 'button--white button--border-blue';
            }
            else if (dataButtonClass === 'salesforceapplynow') {
                dataIntent = 'Transactional';
                dataClass = 'button--main';
            }
            else if (dataButtonClass === 'compare') {
                dataIntent = 'Comparison;';
                dataClass = 'button--white button--border-blue';
            }
        }
        if (show) {
            if (button.modalId) {
                output += '<a class="button ' + dataClass + ' js-apply-now-modal-open" href="javascript:void(0)" target="" data-productname="' + product.title + '" data-modal="apply-now-modal-' + button.modalId + '" data-intent="' + dataIntent + '" data-scope="comparisonExchange" data-id="link_content_compare bank accounts" data-text="' + product.title + ' | ' + button.title + ' button click" data-leadid="' + leadid + '">';
            }
            else if (button.buttonClass === 'Apply') {
                output += '<a class="button ' + dataClass + '" href="javascript:void(0)" target="" data-productname="' + product.title + '" target="" data-intent="' + dataIntent + '" data-scope="comparisonExchange" data-id="link_content_compare bank accounts" data-text="' + product.title + ' | ' + button.title + ' button click" data-leadid="' + leadid + '">';
            }
            else if (index == 0 || button.buttonClass === 'Eligibility' || button.buttonClass === 'ContactUs' || button.buttonClass === 'CallMeBack') {
                output += '<a class="button ' + dataClass + '" href="' + button.url + '" target="" data-productname="' + product.title + '" target="" data-intent="' + dataIntent + '" data-scope="comparisonExchange" data-id="link_content_compare bank accounts" data-text="' + product.title + ' | ' + button.title + ' button click" data-leadid="' + leadid + '">';
            }
            else {
                output += '<a class="button ' + dataClass + '" href="' + button.url + '" target="" data-productname="' + product.title + '" target="" data-intent="' + dataIntent + '" data-scope="comparisonExchange" data-id="link_content_compare bank accounts" data-text="' + product.title + ' | ' + button.title + ' button click">';
            }
        }
        else {
            if (button.modalId) {
                output += '<a class="button ' + dataClass + ' js-apply-now-modal-open d-none" href="javascript:void(0)" target="" data-productname="' + product.title + '" data-modal="apply-now-modal-' + button.modalId + '" data-intent="' + dataIntent + '" data-scope="comparisonExchange" data-id="link_content_compare bank accounts" data-text="' + product.title + ' | ' + button.title + ' button click" data-leadid="' + leadid + '">';
            }
            else if (button.buttonClass === 'Apply') {
                output += '<a class="button ' + dataClass + ' d-none" href="javascript:void(0)" target="" data-productname="' + product.title + '" target="" data-intent="' + dataIntent + '" data-scope="comparisonExchange" data-id="link_content_compare bank accounts" data-text="' + product.title + ' | ' + button.title + ' button click" data-leadid="' + leadid + '">';
            }
            else if (index == 0 || button.buttonClass === 'Eligibility' || button.buttonClass === 'ContactUs' || button.buttonClass === 'CallMeBack') {
                output += '<a class="button ' + dataClass + ' d-none" href="' + button.url + '" target="" data-productname="' + product.title + '" target="" data-intent="' + dataIntent + '" data-scope="comparisonExchange" data-id="link_content_compare bank accounts" data-text="' + product.title + ' | ' + button.title + ' button click" data-leadid="' + leadid + '">';
            }
            else {
                output += '<a class="button ' + dataClass + ' d-none" href="' + button.url + '" target="" data-productname="' + product.title + '" target="" data-intent="' + dataIntent + '" data-scope="comparisonExchange" data-id="link_content_compare bank accounts" data-text="' + product.title + ' | ' + button.title + ' button click">';
            }
        }
        return output;
    };
    ComparisonExchange.prototype.checkCheckBoxes = function () {
        var length = this.storageComparison[this.productKey].length;
        if (length > 0) {
            this.element.classList.add('comparison-exchange--comparing');
            if (length === 3) {
                $('.comparison-exchange__compare-checkbox input').prop('disabled', 'disabled');
                this.storageComparison[this.productKey].forEach(function (id) {
                    console.log('ID: ' + id);
                    $('.comparison-exchange__compare-checkbox input[data-id=' + id + ']').removeAttr('disabled');
                });
            }
        }
    };
    ComparisonExchange.prototype.recheckButton = function (element) {
        var _this = this;
        if (element) {
            var modalId_1 = element.getAttribute('data-modal');
            var getModalIdRechecks = Array.from(this.element.querySelectorAll('a.js-recheck-eligibility[data-modal=' + modalId_1 + ']'));
            getModalIdRechecks.forEach(function (button) {
                var parentContainer = button.closest('.comparison-exchange__product__section');
                var messageContainer = parentContainer.querySelector('.comparison-exchange__product__section-eligibility--message');
                var buttonsContainer = parentContainer.querySelector('.comparison-exchange__product__section-buttons');
                var buttons = Array.from(buttonsContainer.querySelectorAll('.comparison-exchange__product__button'));
                buttons.forEach(function (container) {
                    var button = container.querySelector('a');
                    button.classList.add('d-none');
                    if (container.getAttribute('data-buttonclass') == "Eligibility" || container.getAttribute('data-buttonclass') == "ProductDetails") {
                        button.classList.remove('d-none');
                    }
                });
                messageContainer.innerHTML = "";
                var storageEligibility = localStorage.getItem('eligibility');
                storageEligibility = JSON.parse(storageEligibility);
                _this.storageEligibility = storageEligibility;
                delete _this.storageEligibility[modalId_1];
                localStorage.setItem('eligibility', JSON.stringify(_this.storageEligibility));
            });
        }
    };
    ComparisonExchange.prototype.symbol = function (value) {
        var key = value;
        key = key.trim().split(' ').join('').toUpperCase();
        switch (key) {
            case "GBP":
                return {
                    title: "GBP",
                    symbolName: "GBP",
                    symbol: "£",
                    image: "/file_source/assets/icons/flag-united-kingdom.svg"
                };
                break;
            case "USD":
                return {
                    title: "USD",
                    symbolName: "USD",
                    symbol: "$",
                    image: "/file_source/assets/icons/flag-united-states.svg"
                };
                break;
            case "ZAR":
                return {
                    title: "ZAR",
                    symbolName: "ZAR",
                    symbol: "R",
                    image: "/file_source/assets/icons/flag-south-africa.svg"
                };
                break;
            case "AUD":
                return {
                    title: "AUD",
                    symbolName: "AUD",
                    symbol: "AU$",
                    image: "/file_source/assets/icons/flag-australia.svg"
                };
                break;
            case "EUR":
                return {
                    title: "EURO",
                    symbolName: "EUR",
                    symbol: "€",
                    image: "/file_source/assets/icons/flag-euro.svg"
                };
                break;
            case "OTHER":
                return {
                    title: "OTHER",
                    symbolName: "OTHER",
                    symbol: "",
                    image: "/file_source/assets/icons/flag-global.svg"
                };
                break;
            case "Other":
                return {
                    title: "OTHER",
                    symbolName: "OTHER",
                    symbol: "",
                    image: "/file_source/assets/icons/flag-global.svg"
                };
                break;
            case "other":
                return {
                    title: "OTHER",
                    symbolName: "OTHER",
                    symbol: "",
                    image: "/file_source/assets/icons/flag-global.svg"
                };
                break;
            default:
                break;
        }
    };
    ComparisonExchange.prototype.actionApplyNow = function (leadId, productName, messageEligibility) {
        if (leadId === void 0) { leadId = ''; }
        if (productName === void 0) { productName = ''; }
        var messageEligiblility = messageEligibility;
        var postData = '';
        postData += 'operation=submit&';
        postData += 'category=individual&';
        postData += 'leadID=' + leadId + '&';
        postData += 'productName=' + productName + '&';
        postData += 'appID=' + this.checkEligibility.applicationID + '&';
        postData += 'productID=' + this.checkEligibility.applicationProductID + '&';
        var analyticsService = new AnalyticsService();
        var url = "/services/SubmitWINLead.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(url, postData, config).then(function (response) {
            var json = response.data;
            if (json) {
                var errors = json.Errors;
                if (errors.length > 0) {
                    errors.forEach(function (error) {
                        analyticsService.dtmRecordSiteError('noerrorcode|' + error + '|' + url);
                        messageEligiblility.classList.add('comparison-exchange__eligibility-message--invalid');
                        if (error.includes('Unknown product')) {
                            messageEligiblility.innerHTML = 'Invalid request';
                        }
                        if (error.includes('Authorization')) {
                            messageEligiblility.innerHTML = 'Invalid request';
                        }
                        if (error.includes('undocumented')) {
                            messageEligiblility.innerHTML = 'Request failed – try again later';
                        }
                        if (error.includes('existing')) {
                            messageEligiblility.innerHTML = 'Your request has already been submitted';
                        }
                    });
                }
                else {
                    var resources = json.Resources;
                    if (resources) {
                        var lmm = resources.LMM;
                        if (lmm) {
                            analyticsService.dtmFormComplete('complete', leadId);
                            window.location = lmm;
                        }
                    }
                }
            }
        }).catch(function (response) {
            analyticsService.dtmRecordSiteError('noerrorcode|' + response + '|' + url);
        });
    };
    return ComparisonExchange;
}(Base));
export { ComparisonExchange };



//////////////////
// WEBPACK FOOTER
// ./components/comparison-exchange/comparison-exchange.component.ts
// module id = 203
// module chunks = 0